"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOverlay = exports.SelectValue = exports.SelectTriggerPrimitive = exports.SelectPlaceholderPrimitive = exports.SelectItemTextWrapperPrimitive = exports.SelectItemIndicatorPrimitive = exports.SelectItemPrimitive = exports.SelectGroupLabel = exports.SelectContentPrimitive = exports.SelectRoot = exports.SelectItemText = exports.SelectGroup = exports.SelectItem = exports.SingleSelect = void 0;
const react_1 = __importStar(require("react"));
const react_select_1 = require("@radix-ui/react-select");
Object.defineProperty(exports, "SelectGroup", { enumerable: true, get: function () { return react_select_1.Group; } });
Object.defineProperty(exports, "SelectItemText", { enumerable: true, get: function () { return react_select_1.ItemText; } });
Object.defineProperty(exports, "SelectRoot", { enumerable: true, get: function () { return react_select_1.Root; } });
Object.defineProperty(exports, "SelectValue", { enumerable: true, get: function () { return react_select_1.Value; } });
const tokens_1 = require("../../../styles/tokens");
const Icon_1 = require("../../Icon/Icon");
const config_1 = require("../Select/config");
const Select_styles_1 = require("./Select.styles");
Object.defineProperty(exports, "SelectContentPrimitive", { enumerable: true, get: function () { return Select_styles_1.StyledContent; } });
Object.defineProperty(exports, "SelectGroupLabel", { enumerable: true, get: function () { return Select_styles_1.StyledGroupLabel; } });
Object.defineProperty(exports, "SelectItemPrimitive", { enumerable: true, get: function () { return Select_styles_1.StyledItem; } });
Object.defineProperty(exports, "SelectItemIndicatorPrimitive", { enumerable: true, get: function () { return Select_styles_1.StyledItemIndicator; } });
Object.defineProperty(exports, "SelectItemTextWrapperPrimitive", { enumerable: true, get: function () { return Select_styles_1.StyledItemTextWrapper; } });
Object.defineProperty(exports, "SelectPlaceholderPrimitive", { enumerable: true, get: function () { return Select_styles_1.StyledPlaceholder; } });
Object.defineProperty(exports, "SelectTriggerPrimitive", { enumerable: true, get: function () { return Select_styles_1.StyledTrigger; } });
exports.SingleSelect = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { open, onOpenChange, children, id, placeholder = "Please select", dimension = "large", disabled, error, "data-testid": testid } = _a, props = __rest(_a, ["open", "onOpenChange", "children", "id", "placeholder", "dimension", "disabled", "error", "data-testid"]);
    const [isOpen, setIsOpen] = (0, react_1.useState)(open !== null && open !== void 0 ? open : false);
    return (react_1.default.createElement(react_select_1.Root, Object.assign({ open: open !== null && open !== void 0 ? open : isOpen, onOpenChange: onOpenChange !== null && onOpenChange !== void 0 ? onOpenChange : setIsOpen }, props),
        react_1.default.createElement(Overlay, { open: open !== null && open !== void 0 ? open : isOpen }),
        react_1.default.createElement(Select_styles_1.StyledTrigger, { id: id, "data-testid": testid, dimension: dimension, "$error": error, disabled: disabled, ref: forwardedRef },
            react_1.default.createElement(Select_styles_1.StyledValueWrapper, null,
                react_1.default.createElement(react_select_1.Value, { placeholder: react_1.default.createElement(Select_styles_1.StyledPlaceholder, null, placeholder) })),
            react_1.default.createElement(Icon_1.Icon, { name: "Arrow", size: tokens_1.buttonInputFieldIconSizes[config_1.DIMENSIONS.MEDIUM]
                    .withText, colour: "night", rotation: !disabled && isOpen ? "up" : "down" })),
        react_1.default.createElement(react_select_1.Portal, null,
            react_1.default.createElement(Select_styles_1.StyledContent, { position: "popper", side: "bottom" },
                react_1.default.createElement(react_select_1.Viewport, null, children)))));
});
exports.SelectItem = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Select_styles_1.StyledItem, Object.assign({}, props, { ref: forwardedRef }),
        react_1.default.createElement(Select_styles_1.StyledItemIndicator, null),
        react_1.default.createElement(Select_styles_1.StyledItemTextWrapper, null,
            react_1.default.createElement(react_select_1.ItemText, null, children))));
});
/**
 * Workaround for touch events propagating to underlying elements
 * https://github.com/radix-ui/primitives/issues/1658
 */
const Overlay = ({ open }) => {
    const [visible, setVisible] = (0, react_1.useState)(open);
    (0, react_1.useEffect)(() => {
        if (!open) {
            const timer = setTimeout(() => {
                setVisible(false);
            }, 200);
            return () => {
                clearTimeout(timer);
            };
        }
        setVisible(true);
        return () => { };
    }, [open]);
    return visible ? (react_1.default.createElement(Select_styles_1.StyledOverlay, { onClick: (e) => e.stopPropagation() })) : null;
};
exports.SelectOverlay = Overlay;
//# sourceMappingURL=Select.js.map